<div
  class="flex w-full min-w-max flex-col gap-2 overflow-y-auto"
  role="menu"
  aria-orientation="vertical"
  [attr.aria-labelledby]="'timepicker-dropdown'">
  <div class="flex justify-between gap-2">
    @for (key of range(); track key) {
      <div
        [class]="getClassesForPart(key)"
        (click)="onSelectPart(key)"
        (keydown)="onSelectPart(key)"
        [tabindex]="key">
        <div class="flex w-full items-center bg-transparent p-0 text-sm">
          <input
            #firstInput
            [id]="'time-input-' + key"
            [value]="getInputValue(key)"
            (keydown)="onKeyInput($event)"
            (keydown.enter)="onInputChange($event, key)"
            (focusout)="onInputChange($event, key)"
            type="text"
            size="1"
            class="block w-full resize-none border-0 bg-none p-0 text-center outline-none" />
        </div>
      </div>
    }
  </div>
  <div
    class="flex h-full max-h-77 min-h-77 max-w-77 min-w-77 flex-col items-center justify-center overflow-x-hidden">
    <svg
      width="260"
      height="260"
      viewBox="0 0 260 260"
      class="rounded-full"
      (mousemove)="onSvgMouseMove($event)"
      (mouseup)="onSvgMouseUp()"
      (mouseleave)="onSvgMouseUp()">
      <!-- Outer circle (hours background) -->
      <circle
        cx="130"
        cy="130"
        r="100"
        fill="transparent"
        stroke="#e5e7eb"
        stroke-width="40"
        class="dark:stroke-zinc-700" />

      <!-- Inner circle (minutes background) -->
      <circle
        cx="130"
        cy="130"
        r="60"
        fill="transparent"
        stroke="#d1d5db"
        stroke-width="30"
        class="dark:stroke-zinc-600" />

      <!-- Hour markers (0-23) on outer circle -->
      @for (hour of hours; track hour) {
        <text
          [attr.x]="getHourPosition(hour).x"
          [attr.y]="getHourPosition(hour).y"
          text-anchor="middle"
          dominant-baseline="central"
          (click)="onHourClick(hour)"
          class="hover:fill-primary-500 dark:hover:fill-primary-400 cursor-pointer fill-zinc-700 text-xs font-medium transition-colors select-none dark:fill-zinc-300">
          {{ hour }}
        </text>
      }

      <!-- Minute markers (every 5 minutes) on inner circle -->
      @for (minute of minuteLabels; track minute) {
        <text
          [attr.x]="getMinutePosition(minute).x"
          [attr.y]="getMinutePosition(minute).y"
          text-anchor="middle"
          dominant-baseline="central"
          (click)="onMinuteClick(minute)"
          class="cursor-pointer fill-zinc-600 text-[10px] font-normal transition-colors select-none hover:fill-blue-500 dark:fill-zinc-400 dark:hover:fill-blue-400">
          {{ minute }}
        </text>
      }

      <!-- Progress arc for window mode (hours) -->
      @if (window()) {
        <circle
          cx="130"
          cy="130"
          r="100"
          fill="transparent"
          stroke="#0B4F4A"
          stroke-width="40"
          [attr.stroke-dasharray]="getStrokeDasharray()"
          [attr.stroke-dashoffset]="getStrokeDashoffset()"
          stroke-linecap="round"
          transform="rotate(-90 130 130)" />
      }

      <!-- Hour pointers -->
      @if (window()) {
        <!-- Start hour pointer -->
        <circle
          [attr.cx]="getHourPointerPosition(0).x"
          [attr.cy]="getHourPointerPosition(0).y"
          r="8"
          fill="#0B4F4A"
          stroke="white"
          stroke-width="2"
          (mousedown)="onHourPointerMouseDown(0)"
          class="cursor-grab" />

        <!-- Finish hour pointer -->
        <circle
          [attr.cx]="getHourPointerPosition(1).x"
          [attr.cy]="getHourPointerPosition(1).y"
          r="8"
          fill="#0B4F4A"
          stroke="white"
          stroke-width="2"
          (mousedown)="onHourPointerMouseDown(1)"
          class="cursor-grab" />
      } @else {
        <!-- Single hour pointer -->
        <circle
          [attr.cx]="getHourPointerPosition(0).x"
          [attr.cy]="getHourPointerPosition(0).y"
          r="8"
          fill="#0B4F4A"
          (mousedown)="onHourPointerMouseDown(0)"
          class="cursor-grab" />
      }

      <!-- Minute pointers -->
      @if (window()) {
        <!-- Start minute pointer -->
        <circle
          [attr.cx]="getMinutePointerPosition(0).x"
          [attr.cy]="getMinutePointerPosition(0).y"
          r="7"
          fill="#3b82f6"
          stroke="white"
          stroke-width="2"
          (mousedown)="onMinutePointerMouseDown(0)"
          class="cursor-grab" />

        <!-- Finish minute pointer -->
        <circle
          [attr.cx]="getMinutePointerPosition(1).x"
          [attr.cy]="getMinutePointerPosition(1).y"
          r="7"
          fill="#3b82f6"
          stroke="white"
          stroke-width="2"
          (mousedown)="onMinutePointerMouseDown(1)"
          class="cursor-grab" />
      } @else {
        <!-- Single minute pointer -->
        <circle
          [attr.cx]="getMinutePointerPosition(0).x"
          [attr.cy]="getMinutePointerPosition(0).y"
          r="7"
          fill="#3b82f6"
          (mousedown)="onMinutePointerMouseDown(0)"
          class="cursor-grab" />
      }
    </svg>
  </div>
</div>
